import html2pdf from "html2pdf.js";

export const generatePrescriptionPDF = async (prescription) => {
    try {
        const template = `
      <div style="margin: 50px;">
        <h1 style="text-align:center; padding:10px; background-color:#71B1CE; font-size:20px; color:#152B37;">
          CONSULTATION SUMMARY
        </h1>

        <div style="margin:20px 0;">
          <p><b>Consultation Date:</b> {{consultationDate}}</p>
          <p><b>Patient ID:</b> {{patientId}}</p>
        </div>

        <h3><b>Chief Complaints</b></h3>
        <ul>{{complaints}}</ul>

        <h3><b>History of Illness</b></h3>
        <ul>{{history}}</ul>

        <h3><b>Notes</b></h3>
        <ul>{{notes}}</ul>

        <h3><b>Allergy</b></h3>
        <ul>{{allergy}}</ul>

        <h3><b>Diagnosis</b></h3>
        <ul>{{diagnosis}}</ul>

        <h3><b>Advice</b></h3>
        <ul>{{advice}}</ul>
        
        <p style="margin-top:40px;">Printed On: {{printedOn}}</p>
      </div>
    `;

        const filledHtml = template
            .replace("{{consultationDate}}", new Date(prescription.created_at).toLocaleString())
            .replace("{{patientId}}", prescription.patient_id)
            .replace("{{complaints}}", prescription.complaints.map(c => `<li>${c}</li>`).join(""))
            .replace("{{history}}", prescription.history_of_illness.map(h => `<li>${h}</li>`).join(""))
            .replace("{{notes}}", prescription.notes.map(n => `<li>${n}</li>`).join(""))
            .replace("{{allergy}}", prescription.allergy.map(a => `<li>${a}</li>`).join(""))
            .replace("{{diagnosis}}", prescription.diagnosis.map(d => `<li>${d}</li>`).join(""))
            .replace("{{advice}}", prescription.advice.map(a => `<li>${a}</li>`).join(""))
            .replace("{{printedOn}}", new Date().toLocaleString());

        // Convert HTML → PDF Blob (NOT auto download)
        const pdfBlob = await html2pdf()
            .from(filledHtml)
            .outputPdf("blob");

        // Create URL and open in new tab
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, "_blank");
    } catch (error) {
        console.error("PDF Error:", error);
        alert("Failed to generate PDF");
    }
};
